<template>
    <div>

        <b-modal id="create-or-update-bank-account" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-bank-account-create-or-update v-model="bank" :errors="errors"></employee-bank-account-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
            
        <v-table    ref="table"
                    with-items
                    up-class="px-1 pb-1"
                    search
                    :items="value"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee-bank-account"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>
        
    </div>
</template>

<script>
import EmployeeBankAccountCreateOrUpdate from './EmployeeBankAccountCreateOrUpdate.vue'
import randomatic from 'randomatic'

export default {
    components:{
        EmployeeBankAccountCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Banka",key:"BankName",thClass:"w-24"},
                // {name:"Şube",key:"BankBranchName",thClass:"w-25"},
                {name:"IBAN",key:"IBAN",thClass:"w-43"},
                {name:"Para Birimi",key:"CurrencyUnitName",thClass:"w-33"},
                {name:"Varsayılan",key:"Default"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            bank:{
                Id:null,
                BankId:null,
                BankName:null,
                BankBranchId:null,
                BankBranchName:null,
                CurrencyUnitId:null,
                CurrencyUnitName:null,
                EmployeeId:null,        
                AccountCode:null,
                IBAN:null,
                Default:false,
            },
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.bank.Id = null
            this.bank.BankId = null
            this.bank.BankName = null
            this.bank.BankBranchId = null
            this.bank.BankBranchName = null
            this.bank.CurrencyUnitId = null
            this.bank.CurrencyUnitName = null
            this.bank.EmployeeId = null        
            this.bank.AccountCode = null
            this.bank.IBAN = null
            this.bank.Default = false
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-bank-account')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.bank.Id = item.Id
            this.bank.BankId = item.BankId
            this.bank.BankName = item.BankName
            this.bank.BankBranchId = item.BankBranchId
            this.bank.BankBranchName = item.BankBranchName
            this.bank.CurrencyUnitId = item.CurrencyUnitId
            this.bank.CurrencyUnitName = item.CurrencyUnitName
            this.bank.EmployeeId = item.EmployeeId   
            this.bank.AccountCode = item.AccountCode
            this.bank.IBAN = item.IBAN
            this.bank.Default = item.Default
            this.$showModal('create-or-update-bank-account')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.bank.IBAN)){
                this.$set(this.errors,'IBAN','IBAN alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.bank.BankId)){
                this.$set(this.errors,'BankId','Banka alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.bank.CurrencyUnitId)){
                this.$set(this.errors,'CurrencyUnitId','Para birimi alanı zorunludur.')
                count ++
            }
            // if(this.$isNullOrEmpty(this.bank.AccountCode)){
            //     this.$set(this.errors,'AccountCode','Hesap numarası alanı zorunludur.')
            //     count ++
            // }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                let id = this.bank.Id ? this.bank.Id : randomatic("A0",10)
                if(this.bank.Id){
                    let item = this.value.find(r=> r.Id == id)
                    this.$set(item,"BankBranchId",this.bank.BankBranchId)
                    this.$set(item,"BankBranchName",this.bank.BankBranchName)
                    this.$set(item,"BankId",this.bank.BankId)
                    this.$set(item,"BankName",this.bank.BankName)
                    this.$set(item,"CurrencyUnitId",this.bank.CurrencyUnitId)
                    this.$set(item,"CurrencyUnitName",this.bank.CurrencyUnitName)
                    this.$set(item,"EmployeeId",this.bank.EmployeeId)
                    this.$set(item,"AccountCode",this.bank.AccountCode)
                    this.$set(item,"IBAN",this.bank.IBAN)
                    this.$set(item,"Default",this.bank.Default)
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:id,
                        BankBranchId:this.bank.BankBranchId,
                        BankBranchName:this.bank.BankBranchName,
                        BankId:this.bank.BankId,
                        BankName:this.bank.BankName,
                        CurrencyUnitId:this.bank.CurrencyUnitId,
                        CurrencyUnitName:this.bank.CurrencyUnitName,
                        EmployeeId:this.id,     
                        AccountCode:this.bank.AccountCode,
                        IBAN:this.bank.IBAN,
                        Default:this.bank.Default,
                        Unsaved:true
                    })
                }
    
                if(this.bank.Default == true){
                    this.value.filter(b=> b.Id != id).forEach(b => { this.$set(b,"Default",false) });
                }
    
                this.$hideModal('create-or-update-bank-account')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem banka hesap bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>